export default "__VITE_ASSET__um3qRpXo__";